import { CellStyleT } from 'ui/AgGridReact/colDefConfig';
import { t } from 'i18next';
import { ACTIONS_FIELD } from 'routes/Admin/UserManagement/Users/UsersGrid/helpers/colDefinitions';
import { ColDef } from 'ag-grid-community';
import { Project } from 'routes/BudgetModule/shared/useGetProjects';

const cellStyleProjectName: CellStyleT = {
    display: 'flex',
    alignItems: 'left',
    borderRight: '0.5px solid lightgray',
};

const cellStyleProjectCount: CellStyleT = {
    display: 'flex',
    justifyContent: 'center',
    borderRight: '0.5px solid lightgray',
};

const cellStyleCentered: CellStyleT = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0px',
};

export const getProjectsColDefinitions = (projects: Project[]): ColDef[] => [
    {
        headerName: t('adminBudgetSpace.projectName'),
        field: 'name',
        flex: 10,
        resizable: true,
        cellRenderer: 'tooltipCellRenderer',
        cellStyle: cellStyleProjectName,
        comparator: (a: string, b: string) =>
            a.toLowerCase().localeCompare(b.toLowerCase()),
    },
    {
        headerName: t('adminBudgetSpace.projectInscriptionCount'),
        flex: 3,
        field: 'inscriptionsCount',
        valueGetter: ({ data }: { data?: Project }) =>
            t('adminBudgetSpace.NInscriptions', {
                count: data?.inscriptionsCount,
            }),
        comparator: (a: string, b: string) =>
            parseInt(a.split(' ')[0], 10) - parseInt(b.split(' ')[0], 10), // Compare only the numeric part of the "n inscription(s)" label
        cellStyle: cellStyleProjectCount,
    },
    {
        field: ACTIONS_FIELD,
        headerName: t('common.actions'),
        cellRenderer: 'actionsCellRenderer',
        cellRendererParams: {
            existingProjectsNames: projects.map(
                (project: Project) => project.name,
            ),
        },
        cellStyle: cellStyleCentered,
        sortable: false,
        flex: 1,
        minWidth: 90,
        valueGetter: ({ data }: { data: Project }) => data,
    },
];
